import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';

import './styles/Header.css';

export default function OnBoardingButton({ selectedTheme, error, state, username, setUsername }) {

  const sanitizeUsername = (value) => value.replace(/\s+/g, '').toLowerCase();

  const handleUsernameChange = (event) => {
    setUsername(sanitizeUsername(event.target.value));
  };

  const handleUsernameKeyDown = (event) => {
    if (event.key === ' ' || event.code === 'Space' || event.keyCode === 32) {
      event.preventDefault();
    }
  };

  const userName = state?.user_session?.user_name || "";
  const hasThemeSelected = Boolean(selectedTheme);
  const greetingPrefix = hasThemeSelected ? "Welcome" : "Welcome";
  const greetingName = hasThemeSelected ? userName : userName;
  
  return (        
    <>
      <h2 className={`onboarding-theme__h2 ${!selectedTheme ? "not-theme" : ""}`}>
        {greetingPrefix} {greetingName}!
      </h2>
      <div className={`onboarding-theme__username ${!selectedTheme ? "not-theme" : ""}`}>
        <label>Choose a username</label>
        <PublicFormInput 
          error={error} 
          element="user_username" 
          margin
          fullWidth={true}
          fixedPlaceholder='@'
          value={username}
          onChange={handleUsernameChange}
          onKeyDown={handleUsernameKeyDown}
          secondaryColor={true}
        />
      </div>

    </>);
}
